import { z } from 'zod'
import { IPIValidator } from '@App/helpers/validate'
import { containsNewLine } from '@App/helpers/work-entities-fields-validators'
import {
    integerMessage,
    newlineMessage,
    numericMessage,
    requiredMessage,
    stringMessage,
    stringSizeMaxMessage,
} from '@Entities/schemas/work/error-messages'

const writerSchema = z.object({
    id: z
        .number({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Writer ID') : numericMessage('Writer ID'),
        })
        .int(integerMessage('Writer role'))
        .optional()
        .nullable(),
    ipId: z.coerce
        .string({
            error: (issue) => (issue.received === 'undefined' ? requiredMessage('IPID') : stringMessage('IPID')),
        })
        .optional()
        .nullable(),
    localId: z
        .number({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Local Id') : numericMessage('Local Id'),
        })
        .int(integerMessage('Local Id'))
        .optional(),
    firstName: z
        .string({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('First name') : numericMessage('First name'),
        })
        .max(60, stringSizeMaxMessage('First name', 60))
        .refine((val) => !containsNewLine(val), newlineMessage('First name'))
        .nullable(),
    lastName: z
        .string({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Last name') : numericMessage('Last name'),
        })
        .max(200, stringSizeMaxMessage('Last name', 200))
        .refine((val) => !containsNewLine(val), newlineMessage('Last name')),
    ipiNumber: z
        .string({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('IPI number') : numericMessage('IPI number'),
        })
        .refine((ipiNumber) => IPIValidator(ipiNumber, false), 'Invalid IPI Number')
        .nullable(),
    roleCode: z.number({ error: requiredMessage('Writer role') }).int(integerMessage('Writer role')),
    writerShare: z.number({ error: numericMessage('Writer share') }).nullable(),
    amend: z.boolean().optional().nullable(),
    worksCount: z
        .number({ error: numericMessage('Works count') })
        .int(integerMessage('Works count'))
        .optional()
        .nullable(),
})

export default writerSchema
